export enum GlobalRoutesPath {
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  TERMS_OF_SALES = 'terms-of-sales',
  PRIVACY_POLICY = 'privacy-policy',
  REFUND_POLICY = 'refund-policy',
  LEGAL_NOTICE = 'legal-notice',
  FREQUENTLY_ASKED_QUESTIONS = 'frequently-asked-questions',
}
